<template>
  <div class="login fixed-nav">
    <MainHeader
      :dark="false"
      :fixedMenu="true"
      :loginButton="true"
      :tiles="false"
      @logoClick="logoClick"
    >
      <svg>
        <use v-if="selectedTranslation === 'en'" xlink:href="#logoWmkSvgEng"></use>
        <use v-else xlink:href="#logoWmkSvg"></use>
      </svg>
    </MainHeader>
    <div class="sections">
      <section class="section-form section-main">
        <LoginForm />
      </section>
      <MainFooter
        key="footer"
        :content="footerData"
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import LoginForm from '@/components/LoginForm.vue'
import MainHeader from '@/components/MainHeader.vue'
import MainFooter from '@/components/MainFooter.vue'

export default {
  name: 'login',
  components: {
    LoginForm,
    MainHeader,
    MainFooter
  },
  methods: {
    ...mapActions([
      'resetActiveFilters'
    ]),
    logoClick () {
      this.$router.push({ 'name': 'virtual' })
    }
  },
  computed: {
    ...mapGetters([
      'footerData',
      'isLoggedIn',
      'selectedTranslation'
    ])
  },
  mounted () {
    this.resetActiveFilters()

    /**
     * Returns to the previous page or menu when user is logged in.
     */
    if (this.isLoggedIn) {
      if (this.$store.state.route && this.$store.state.route.from && this.$store.state.route.from.fullPath) {
        if (this.$store.state.route.from.fullPath !== '/login' && this.$store.state.route.from.fullPath !== '/rejestracja') {
          this.$router.push({ 'path': this.$store.state.route.from.fullPath })
        } else {
          this.$router.push({ 'name': 'menu' })
        }
      } else {
        this.$router.push({ 'name': 'menu' })
      }
    }
  }
}
</script>

<style scoped lang="scss">
</style>
